import { ADMIN_TYPE } from "@/enum";

export default [
  {
    path: "/flight-routes",
    meta: {
      requiresAuth: true,
      permission: null,
      title: "Rutas de vuelo",
      layout: "admin",
      module: "flight-routes",
      icon: "mdi-airplane-takeoff",
      notBreadCrumb: true,
      roles: [ADMIN_TYPE.RIDERY]
    },
    component: () =>
      import(
        /* webpackChunkName: "FlightRoutesLayout" */ "@/views/flight-routes/FlightRoutesLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "flight-routes-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "flight-routes",
          title: "Listado",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "FlightRoutesList" */ "@/views/flight-routes/FlightRoutesList.vue"
          ),
      },
    ],
  },
];
